import { render } from "./DonneesClinique.vue?vue&type=template&id=8d80b54c&scoped=true"
import script from "./DonneesClinique.vue?vue&type=script&lang=js"
export * from "./DonneesClinique.vue?vue&type=script&lang=js"

import "./DonneesClinique.vue?vue&type=style&index=0&id=8d80b54c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d80b54c"]])

export default __exports__